import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/audit")({
  component: () => (
    <div className="rounded-xl border border-border bg-card p-6">
      <h2 className="text-base font-medium">Audit Log</h2>
      <p className="mt-1 text-sm text-muted-foreground">
        Sensitive platform actions, immutable trail. Coming in the next release.
      </p>
    </div>
  ),
});
